import { FC, useCallback } from "react";
import { PageWrapper } from "@connectedComponents";
import { stackEnum } from "@utilities/enums";
import { Icon } from "@components";
import { useController } from "./useController";

export const Stocks: FC = () => {

    const { stockMenu, navigateTo } = useController();

    return (
        <PageWrapper
            activeStack={stackEnum.stocksStack}
        >
            <div
                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
            >
                { stockMenu.map((menu, i) => (
                    <div 
                        key={i}
                        className={`card p-4 shadow-md hover:shadow-lg cursor-pointer w-full sm:max-w-xs md:max-w-sm text-white ${menu.classname}`}
                        onClick={()=> navigateTo(menu.link)}
                    >
                        <div className="flex flex-col items-center">
                            <Icon iconName={menu.icon as any} size={30} />
            
                            <h2
                                className="card-title text-lg sm:text-xl md:text-2xl text-center"
                            >{menu.label}</h2>
                        </div>
                    </div>
                )) }
            </div>
        </PageWrapper>
    );
};
